import type { EmailActivity } from '@common/types/activities';
import { Box, Link, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function ApprovalEmailBody({ emailBody, isBodyExpanded, setIsBodyExpanded }: Props) {
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography variant="h4" sx={{ marginBottom: '16px' }}>
                Quote request response
            </Typography>
            <Typography variant="body2" color="text.primary">
                {emailBody?.ClientName} has accepted the Quote.
            </Typography>
            <Typography variant="h4" sx={{ marginTop: '20px' }} display="inline">
                Email:
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.primary', marginLeft: '8px' }}
                display="inline"
            >
                <a href={`mailto:${emailBody?.ClientEmail}`}>{emailBody?.ClientEmail}</a>
            </Typography>
            <br />
            <Typography variant="h4" display="inline">
                Phone Number:
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.primary', marginLeft: '8px' }}
                display="inline"
            >
                {emailBody?.ClientPhoneNumber}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                You can see additional information about the client{' '}
                <Link
                    href={emailBody?.ProspectLink}
                    sx={{ textDecoration: 'none', cursor: 'pointer' }}
                >
                    here
                </Link>
                .
            </Typography>
            <ShowLessButton
                isBodyExpanded={isBodyExpanded}
                bodyExpandedHandler={setIsBodyExpanded}
            />
        </Box>
    );
}
